import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./disclaimer-dialog-body.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./disclaimer-dialog-body.component.scss?ngResource";
import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { SubscriberComponent } from "../../../shared/components/subscriber/subscriber.component";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { DisclaimerDialogBodyConstants } from "./disclaimer-dialog-body.constants";
import { AppConfig } from "../../../app.config";
import { RequestStatusService } from "../../../shared/services/request-status/request-status.service";
export let DisclaimerDialogBodyComponent = class DisclaimerDialogBodyComponent extends SubscriberComponent {
    dialogRef;
    router;
    http;
    requestStatusService;
    disclaimerTitle = "";
    disclaimerContent = "";
    acceptDisclaimerURL = DisclaimerDialogBodyConstants.ACCEPT_DISCLAIMER_URL;
    acceptButtonLabel = DisclaimerDialogBodyConstants.ACCEPT_DISCLAIMER_TEXT;
    constructor(dialogRef, router, http, requestStatusService) {
        super();
        this.dialogRef = dialogRef;
        this.router = router;
        this.http = http;
        this.requestStatusService = requestStatusService;
    }
    ngOnInit() {
        this.disclaimerTitle = AppConfig.settings.disclaimer.title;
        this.disclaimerContent = AppConfig.settings.disclaimer.content;
    }
    acceptDisclaimer($event) {
        this.requestStatusService.showBusySpinner("Accept disclaimer");
        this.cleanupAfterDestroy(this.http.post(this.acceptDisclaimerURL, {}))
            .subscribe(response => {
            this.closeDisclaimer();
            this.requestStatusService.removeBusySpinner("Accept disclaimer");
        });
    }
    closeDisclaimer() {
        this.dialogRef.close(true);
    }
    static ctorParameters = () => [
        { type: MatDialogRef },
        { type: Router },
        { type: HttpClient },
        { type: RequestStatusService }
    ];
};
DisclaimerDialogBodyComponent = __decorate([
    Component({
        selector: "app-dialog-body",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], DisclaimerDialogBodyComponent);
